import { Text, YStack } from '../../Primitives';

export const ClerkLoading = () => (
  <YStack gapY="sm" p="md">
    <Text type="h4">Setting up sign-in…</Text>
  </YStack>
);
